import colors from './colors';
import fonts from './fonts';
import indices from './indices';
import layouts from './layouts';
import mediaQueries from './mediaQueries';
import mixins from './mixins';

const theme = {
  colors,
  fonts,
  indices,
  layouts,
  mediaQueries,
  mixins,
};

export default theme;
